<template>
  <div class="matches mt-8" v-if="!ignored">
    <div v-if="isUpdating">
      <v-skeleton-loader v-for="i in 3" :key="i" type="list-item" />
    </div>
    <div v-else>
      <v-list-item>
        <v-list-item-avatar tile>
          <v-img
            height="30px"
            contain
            src="@/assets/svg/booking_list_icon.svg"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <div
            class="d-flex justify-space-between align-center"
            :class="{ 'flex-column': isMobile }"
          >
            <div>
              <h3>{{ booking.title }}</h3>
              <div class="mt-1">
                {{ annualSalary }}
              </div>
            </div>
            <p class="secondary-text">{{ dateForHuman }}</p>
          </div>
        </v-list-item-content>
      </v-list-item>
      <div class="d-flex my-4" :class="{ 'flex-column': isMobile }">
        <LabeledText label="Contract Type" class="mr-6">
          {{ booking.contractType || "-" }}
        </LabeledText>
        <LabeledText label="Working Hours" class="mr-8">
          {{ booking.workingHours || "-" }}
        </LabeledText>
        <LabeledText label="Closing Date">
          {{ closingDate }}
        </LabeledText>
      </div>
      <div class="rich-text-container" v-html="booking.externalDescription" />
      <div class="text-center my-4">
        <SecondaryButton
          class="px-6 py-3"
          @click.native="handleIgnore"
          light
          textColor="#d10a3a"
        >
          <div class="f-flex">
            <v-icon>
              mdi-eye-off-outline
            </v-icon>
            Ignore
          </div>
        </SecondaryButton>
        <SecondaryButton
          class="px-6 py-3"
          :class="{ 'ml-1': !isMobile, 'mt-1': isMobile }"
          @click.native="handleApply"
          light
          textColor="#0a70f5"
        >
          <div class="f-flex">
            <v-icon>
              mdi-file-document-outline
            </v-icon>
            Apply
          </div>
        </SecondaryButton>
      </div>
    </div>

    <v-divider />
  </div>
</template>

<script>
import moment from "moment";
import { DEFAULT_CURRENCY } from "@/constants/common";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import {
  UPDATE_MATCH,
  FETCH_MATCHES
} from "@/store/modules/dashboard/action-types";
import { DASHBOARD_NAMESPACE } from "@/store/modules/dashboard";
import { createNamespacedHelpers } from "vuex";
import { dateForHuman } from "@/utils/time";

const { mapActions } = createNamespacedHelpers(DASHBOARD_NAMESPACE);

export default {
  props: {
    match: {
      type: Object,
      required: true
    }
  },
  components: { LabeledText, SecondaryButton },
  data() {
    return {
      isUpdating: false,
      ignored: false
    };
  },
  computed: {
    booking() {
      return this.match.booking || {};
    },
    dateForHuman() {
      return dateForHuman(this.match.date);
    },
    salaryCurrencyCode() {
      return this.booking.salaryCurrencyCode || DEFAULT_CURRENCY;
    },
    annualSalary() {
      const currency = this.$options.filters.currency;
      return `${currency(
        this.booking.salaryBandLower,
        this.salaryCurrencyCode
      )}-${currency(this.booking.salaryBandUpper, this.salaryCurrencyCode)}`;
    },
    closingDate() {
      return moment(this.booking.deadlineDate).format("dddd Do MMMM");
    }
  },
  methods: {
    ...mapActions({
      updateMatch: UPDATE_MATCH,
      fetchMatches: FETCH_MATCHES
    }),
    async handleIgnore() {
      this.isUpdating = true;
      await this.updateMatch({
        matchId: this.match.id,
        data: { status: "ignored" }
      });
      this.isUpdating = false;
      this.ignored = true;
      const user = this.match.user || {};
      this.fetchMatches(user.id);
    },
    handleApply() {
      this.$router.push({
        name: "profile",
        query: { booking_id: this.booking.id }
      });
    }
  }
};
</script>
